import React, { Component } from "react";
import { BloxButton } from "styled_components/Common/BloxButton";
import { TicketApi } from "services/ticket";
import ExpandableSection from "sub_components/Common/ExpandableSection";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { STATUS } from "utils/TicketConstants";
import { getTicketTitle } from "utils/SupportUtils";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { RESOLUTIONS } from "services/config";
import { findIana } from "windows-iana";
import { DataCenterApi } from "services/datacenter";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { SuccessMessage, ErrorMessage } from "utils/CommonConstants";
import { EventDetail } from "styled_components/Support/EventDetails";
import { MicrosoftApi } from "services/microsoft";
import { DIMENSIONS } from "services/layoutManager";
import { TicketLocation } from "styled_components/Support/TicketLocation";
import { Comments } from "styled_components/Support/Comments";
import { getTicketTypeIcon } from "utils/SupportUtils";
import { Utils } from "services/utils";
import { UserProfileApi } from "services/userProfile";
import CalendarModal from "sub_components/Common/CalendarModal";
//import { TicketDescription } from 'styled_components/Support/TicketDescription';
import Joyride from "react-joyride-react-19";
import format from "date-fns/format";
import set from "date-fns/set";
import add from "date-fns/add";
import areIntervalsOverlapping from "date-fns/areIntervalsOverlapping";
import { TicketDetails } from "styled_components/Support/TicketDetails";
import Modal from "sub_components/Common/PortalModalNew";
import AttachmentModal from "blox_components/Support/TicketHistory/Components/Conversations/AttachmentModal";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const LowSeverityFlag = `${CDN_URL}support/image-flag-low.svg`;
const MedSeverityFlag = `${CDN_URL}support/image-flag-med.svg`;
const HighSeverityFlag = `${CDN_URL}support/image-flag-high.svg`;
const TopIcon = `${CDN_URL}support/image-what.svg`;

const SEVERITY_IMAGE = {
  low: LowSeverityFlag,
  medium: MedSeverityFlag,
  high: HighSeverityFlag,
};
const ATTACHMENT_UPDATE_INTERVAL = 15000;

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    location: { x: 0, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    details: { x: 0, y: 22, dim: DIMENSIONS.TWO_BY_SIX, customHeight: 43 },
    //description: { x: 8, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    comments: { x: 8, y: 0, dim: DIMENSIONS.FOUR_BY_SIX, customHeight: 43 },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    location: { x: 2, y: 0, dim: DIMENSIONS.TWO_BY_FOUR },
    details: { x: 2, y: 29, dim: DIMENSIONS.TWO_BY_FOUR, customHeight: 50 },
    //description: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    comments: { x: 6, y: 0, dim: DIMENSIONS.FOUR_BY_SIX },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    location: { x: 2, y: 0, dim: DIMENSIONS.TWO_BY_FOUR },
    details: { x: 2, y: 50, dim: DIMENSIONS.TWO_BY_FOUR, customHeight: 80 },
    //description: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    comments: { x: 6, y: 0, dim: DIMENSIONS.FOUR_BY_SIX },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class TicketHistoryDetail extends Component {
  constructor(props) {
    super(props);
    const tomorrow = add(new Date(), { days: 1 });
    this.userProfileApi = new UserProfileApi();
    this.state = {
      ticketDetails: null,
      error: null,
      cancelRequested: false,
      cancelEventRequested: false,
      showUpdateModal: false,
      cancelConfirmed: false,
      eventDetails: null,
      selectedDay: tomorrow,
      newAttachments: [],
      startdatetime: set(tomorrow, { hours: 9 }),
      enddatetime: set(tomorrow, { hours: 10 }),
      duration: { value: 60, label: "1h" },
      clicked: false,
      datacenter: null,
      attendees: null,
      showStart: false,
      title: "description",
      attachmentModalOpen: false,
      attachmentErrors: [],
      comment: "",
      comments: [],
      attachments: null,
      eventId: null,
      timeoutId: null,
    };
  }

  blobToBase64 = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  getBase64StringFromDataURL = (dataURL) =>
    dataURL.replace("data:", "").replace(/^.+,/, "");

  toggleAttachmentModal = () => {
    const { attachmentModalOpen } = this.state;
    this.setState({ attachmentModalOpen: !attachmentModalOpen });
  };

  formTicketParamsTemp = async () => {
    const {
      comment,
      newAttachments,
      attachmentErrors,
      ticketDetails: ticket,
    } = this.state;
    const {
      auth_status,
      auth_status: { user: { firstname = {}, lastname = {} } } = {},
      company_info: {
        customer: { id },
      },
    } = this.props;
    const tickets = [];

    let errorMessages = "";

    attachmentErrors.forEach((file) => {
      errorMessages += `${file.filename} could not be attached: ${file.error}\n`;
    });
    const sharedUserData = sessionStorage.getItem("sharedUser");
    let commentedBy = `${firstname} ${lastname}`;

    if (sharedUserData) {
      const { name } = JSON.parse(sharedUserData);
      commentedBy = name;
    }

    let newComment =
      errorMessages === ""
        ? comment
        : `${comment}\nUpload errors:\n${errorMessages}`;

    if (newComment === "" || newComment === null) {
      newComment = "Attachment added.";
    }

    for (let i = 0; i <= newAttachments.length - 1; i++) {
      const attachment_location = newAttachments[i].data_id;
      const { filename, file } = newAttachments[i];
      const blob = new Blob([file]);
      const base64 = await this.blobToBase64(blob);
      tickets.push({
        caseid: ticket?.process_id,
        comment:
          i === 0
            ? newComment +
              `\nAttachment added: ${filename} ` +
              `\nCommented By: ${commentedBy}`
            : "Comment Attachment",
        files: [
          {
            userId: auth_status.user.id,
            attachment_location,
            filename,
            fileContent: this.getBase64StringFromDataURL(base64),
          },
        ],
        status: ticket.status,
        filename,
        organizationId: id,
        userId: auth_status.user.id,
        jiraId: ticket.jira_ticket,
      });
    }

    return tickets;
  };
  formTicketParams() {
    const {
      comment,
      newAttachments,
      attachmentErrors,
      ticketDetails: ticket,
    } = this.state;
    const {
      auth_status,
      auth_status: { user: { firstname = {}, lastname = {} } } = {},
      company_info: {
        customer: { id },
      },
    } = this.props;
    const files = [];

    newAttachments.forEach((attachment) => {
      files.push({
        userId: auth_status.user.id,
        attachment_location: attachment.data_id,
        filename: attachment.filename,
      });
    });
    let errorMessages = "";

    attachmentErrors.forEach((file) => {
      errorMessages += `${file.filename} could not be attached: ${file.error}\n`;
    });

    const sharedUserData = sessionStorage.getItem("sharedUser");
    let commentedBy = `${firstname} ${lastname}`;

    if (sharedUserData) {
      const { name } = JSON.parse(sharedUserData);
      commentedBy = name;
    }

    let newComment =
      errorMessages === ""
        ? comment
        : `${comment}\nUpload errors:\n${errorMessages}`;

    if (newComment === "" || newComment === null) {
      newComment = "Attachment added. " + `\nCommented By: ${commentedBy}`;
    }

    return {
      caseid: ticket.process_id,
      comment: newComment + `\nCommented By: ${commentedBy}`,
      files,
      status: ticket.status,
      filename: "",
      organizationId: id,
      userId: auth_status.user.id,
      jiraId: ticket.jira_ticket,
    };
  }
  createMultipleTicket = (ticket, resolve) => {
    TicketApi.updateTicket(ticket)
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        resolve(response);
      });
  };

  getTicketComments = async (jiraIssue) => {
    try {
      const response = await TicketApi.getTicketComments(jiraIssue);
      if (response.status === 200 && !response.data.error) {
        this.setState({ comments: response.data.comments });
      }
    } catch (e) {
      console.log(e);
    }
  };

  getTicketAttachments = async (ticketId) => {
    try {
      const response = await TicketApi.getTicketAttachments(ticketId);
      if (response.status === 200 && !response.data.error) {
        this.setState({ attachments: response.data.attachments });
      }
    } catch (e) {
      console.log(e);
    }
  };

  retrieveTicket = (id) => {
    TicketApi.getTicket(id)
      .then((response) => {
        if (response.status === 200) {
          try {
            const { ticketDetails } = response.data;

            //this.sendTicketDetailsToParent(ticketDetails.requester);

            this.setState({
              ticketDetails,
              convos: ticketDetails.comments,
              comment: "",
              attachments: ticketDetails.attachments,
              //phase: PHASE.NOT_STARTED,
            });
            if (ticketDetails?.jira_ticket) {
              this.getTicketComments(ticketDetails?.jira_ticket);
            }
          } catch (e) {
            console.log(e);
          }
        }
      })
      .catch((error) => console.log("Error retrieving ticket: ", error));
  };

  setDescription = (value) => {
    this.setState({ comment: value });
  };

  formatAttachments = (attachments) => {
    const formattedAttachments = [];

    attachments &&
      attachments.forEach(async (attachment) => {
        const filename = attachment.filename;
        const formattedAttachment = {
          File: filename,
          Type: filename.split(".").pop(),
          FileContent: attachment?.fileContent,
        };
        formattedAttachments.push(formattedAttachment);
      });
    return formattedAttachments;
  };

  createTicket = (ticket) => {
    const { setModalContent } = this.props;
    TicketApi.updateTicket(ticket)
      .then((response) => {
        const isSuccess =
          response.status === 200 && !response.data.error && !response.error;
        const msg = isSuccess
          ? "Comment added successfully!"
          : "Sorry, there was an error adding the comment";

        const button = (
          <BloxButton
            className="buttons41"
            id="okay"
            text="OKAY"
            module="support"
            enabled={true}
            onClick={() => {}}
            cypressId="okay"
          />
        );
        setModalContent("TIMEOUT_CLOSE", msg, button);

        this.setState({ comment: "", newAttachments: [] });
      })
      .catch(() => {
        this.setState({ comment: "", newAttachments: [] });
      });
  };

  onSubmit = async () => {
    const { setModalContent, ticketRequestType } = this.props;
    const { newAttachments } = this.state;
    let tickets = null;
    let ticket = null;
    const successfulCalls = [];

    if (newAttachments.length) {
      tickets = await this.formTicketParamsTemp();
    } else {
      ticket = await this.formTicketParams();
    }

    if (ticket) {
      if (ticketRequestType === "support") {
        this.createTicket(ticket);
      }
    } else if (tickets) {
      for (const ticket of tickets) {
        if (ticketRequestType === "support") {
          await new Promise((resolve) =>
            this.createMultipleTicket(ticket, resolve)
          )
            .then((response) => {
              const isSuccess =
                response.status === 200 &&
                !response.data.error &&
                !response.error;
              if (isSuccess) {
                successfulCalls.push(true);
              }
            })
            .catch();
        }
      }
      let msg = "";
      if (successfulCalls.length === tickets.length) {
        msg = "Comment added successfully!";
      } else {
        msg = "Sorry, there was an error adding the comment";
      }
      const button = (
        <BloxButton
          className="buttons41"
          id="okay"
          text="OKAY"
          module="support"
          enabled={true}
          onClick={() => {}}
          cypressId="okay"
        />
      );
      setModalContent("TIMEOUT_CLOSE", msg, button);
      this.setState({
        msg,
        comment: "",
        //phase: PHASE.TICKET_SUBMITTED,
        newAttachments: [],
      });
    }
  };

  formatCancelTicketParams = (ticket) => {
    const {
      userId,
      auth_status: { user: { firstname = {}, lastname = {} } } = {},
    } = this.props;
    const { process_id = 0, invite_id, customer_id } = ticket;

    return {
      caseid: process_id,
      comment:
        "Ticket has been cancelled" +
        `\nCommented By: ${firstname} ${lastname}`,
      status: STATUS.SOLVED,
      invite_id,
      organizationId: customer_id,
      userId,
      jiraId: ticket.jira_ticket,
    };
  };

  getTicketStatus(details) {
    if (!details || !details.status) {
      return "OPEN";
    }

    return details.status;
  }

  toggleCancelModal = () => {
    this.setState({ cancelRequested: false, cancelConfirmed: false });
  };

  onCancelRequest = () => {
    this.setState({ cancelRequested: true }, () => this.checkModal());
  };
  onCancelEventRequest = () => {
    this.setState({ cancelEventRequested: true }, () => this.checkEventModal());
  };

  setLocation = (location) => {
    let datacenter = "";
    switch (location) {
      case "Atlanta":
        datacenter = "ATL";
        break;
      case "Huntsville":
        datacenter = "HSV";
        break;
      case "Chattanooga":
        datacenter = "CHA";
        break;
      case "Birmingham":
        datacenter = "BHM";
        break;
      default:
        datacenter = location;
    }
    return datacenter;
  };
  getStartOfWeek = (dcs) => {
    const { datacenters, ticketDetails } = this.state;
    const location = ticketDetails?.location;
    let dcList = null;
    if (!datacenters) {
      dcList = dcs;
    }
    const datacenter = this.setLocation(location);

    const selectedDC = dcList && dcList.filter((dc) => dc.name === datacenter);

    if (selectedDC[0]) {
      const ianaTimeZone = findIana(selectedDC[0]?.timezone);

      const startOfWeek = startOfWeek(new Date(), { locale: ianaTimeZone[0] });

      this.setState({ currentTimezone: selectedDC[0]?.timezone, datacenter });

      return startOfWeek;
    }
  };

  onCancelConfirm = async () => {
    const { ticketDetails } = this.state;
    const { setModalContent, ticketRequestType } = this.props;

    setModalContent("CLOSE");
    let params = null;
    if (ticketRequestType === "support") {
      params = this.formatCancelTicketParams(ticketDetails);
    }

    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="support"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    try {
      let response = null;
      if (ticketRequestType === "support") {
        response = await TicketApi.updateTicket(params);
      }

      if (response.status === 200 && !response.error) {
        setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
        this.setState({ cancelRequested: false, cancelConfirmed: false });
      } else {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);

        this.setState({
          error: "Unable to cancel ticket",
          cancelRequested: false,
          cancelConfirmed: false,
        });
      }
    } catch (e) {
      console.log(e);
      setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);

      this.setState({
        error: "Unable to cancel ticket",
        cancelRequested: false,
        cancelConfirmed: false,
      });
    }
  };

  componentWillUnmount() {
    clearInterval(this.attachmentInterval);
    this.setState({ ticketDetails: null });
  }

  retrieveTicketDetails = async (id) => {
    try {
      const response = await TicketApi.getTicket(id);

      if (
        response.status === 200 &&
        !response.data.error &&
        response.data.ticketDetails?.process_id
      ) {
        const { ticketDetails = {} } = response.data;
        this.setState({
          ticketDetails,
          attachments: ticketDetails?.attachments,
        });

        if (ticketDetails?.jira_ticket) {
          this.getTicketComments(ticketDetails.jira_ticket);
        }

        if (ticketDetails?.invite_id) {
          this.setState({ eventId: ticketDetails?.invite_id });
        }
      } else {
        const { error = "Error retrieving details" } = response.data;
        if (error) {
          this.setState({ error });
        } else {
          this.setState({ error: "Error retrieving details" });
        }
      }
    } catch (e) {
      console.log(e);
      this.setState({ error: "Network error" });
    }
  };
  formatTicketDetails = (ticket) => {
    return {
      status: ticket?.Status,
      description: ticket?.Description,
      created_date_time: ticket?.SubmitDate,
      updated_date_time: ticket?.DueDate,
      requester: ticket?.ItemOwner,
      status: ticket?.Status,
      title: ticket?.Summary,
      priority: ticket?.UDF_CustomerDefinedPriority,
      type: "support",
      request_type: "support",
      invite_id: ticket?.ExternalItemID,
      location: Utils.getLocationTagByID(ticket?.ServiceLocation),
      id: ticket?.ID,
      eTag: ticket?.eTag,
    };
  };

  getIcon = (ticket) => {
    const { priority } = ticket;

    if (priority) {
      return SEVERITY_IMAGE[priority];
    } else {
      return SEVERITY_IMAGE.low;
    }
  };

  parseDescription = (title, description) => {
    const sharedUserData = sessionStorage.getItem("sharedUser");
    let desc = "";

    const ticketTitle = title ? `${title}<br />` : "";
    if (description) {
      desc = ticketTitle + description.split("\n").join("<br />");
    } else {
      desc = "";
    }
    if (sharedUserData) {
      const { name, email } = JSON.parse(sharedUserData);
      desc += `Shared User Name: ${name}\n`;
      desc += `Shared User Email: ${email}\n`;
    }
    return desc;
  };

  getDescriptionCardParams = (ticket) => {
    const { description, title } = ticket;

    return {
      1: {
        label: "Description",
        custom: true,
        type: ExpandableSection,
        params: {
          name: "description",
          content: this.parseDescription(title, description),
        },
      },
    };
  };
  getAttachmentCardParams = (ticket) => {
    const { attachments } = ticket;

    return (
      <div className="attachment-component-wrapper">
        <ScrollView purple>
          {attachments.map((attachment) => (
            <a
              href={`${BASE_URL}/support/attachment/${attachment?.attachment_location}`}
              download
            >
              <div className="file-name">{attachment.filename}</div>
            </a>
          ))}
        </ScrollView>
      </div>
    );
  };
  cancelEvent = () => {
    const { ticketDetails } = this.state;
    const { setModalContent } = this.props;
    const id = ticketDetails?.invite_id;
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="support"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    MicrosoftApi.cancelEvent(id)
      .then((response) => {
        const validResponse =
          response.status === 200 && response.data?.eventUpdated;
        setModalContent("CLOSE");
        if (validResponse) {
          setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
        } else {
          setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
        }
      })
      .catch(() => {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      });
  };
  setEventDetails = (details) => {
    const attendees = details?.attendees;
    const newAttendees = [];
    attendees.map((attendee) =>
      newAttendees.push({
        email: attendee?.emailAddress?.address,
        type: attendee?.type,
      })
    );

    this.setState({ eventDetails: details, attendees: newAttendees }, () => {
      this.setState({
        startdatetime: details?.startDateTime?.dateTime,
        enddatetime: details?.endDateTime?.dateTime,
      });
    });
  };

  getEventCardParams = () => {
    const { showUpdateModal, eventId, ticketDetails } = this.state;
    const datacenter = ticketDetails?.location;
    return (
      <div className="event-component-wrapper">
        <div className="expandable-component-body">
          <EventDetail
            eventId={eventId}
            datacenter={datacenter}
            cancelEvent={this.onCancelEventRequest}
            toggleUpdateModal={this.toggleUpdateModal}
            setEventDetails={this.setEventDetails}
            showUpdateModal={showUpdateModal}
          />
        </div>
      </div>
    );
  };
  getShippingCardParams = (ticket) => {
    return (
      <div className="event-component-wrapper">
        <div className="expandable-component-body">
          <img src={ticket?.record_id} />
        </div>
      </div>
    );
  };

  setupAttachmentInterval = (id) => {
    this.attachmentInterval = setInterval(() => {
      this.updateTicketConvo(id);
    }, ATTACHMENT_UPDATE_INTERVAL);
  };

  updateTicketConvo = async (id) => {
    TicketApi.getTicket(id)
      .then((response) => {
        if (response.status === 200) {
          try {
            const { ticketDetails = {} } = response.data;
            this.setState({ ticketDetails });
            if (ticketDetails?.jira_ticket) {
              this.getTicketComments(ticketDetails?.jira_ticket);
            }
          } catch (e) {
            console.log(e);
          }
        }
      })
      .catch((error) =>
        console.log("Error updating ticket conversation: ", error)
      );
  };

  componentDidMount() {
    const { id } = this.props;
    this.getCalendarView();
    this.getDatacenters();

    this.retrieveTicketDetails(id);

    this.setupAttachmentInterval(id);
  }
  componentDidUpdate(prevProps) {
    const { id, ticketRequestType } = this.props;

    if (
      prevProps.id !== id ||
      prevProps.ticketRequestType !== ticketRequestType
    ) {
      clearInterval(this.attachmentInterval);
      if (ticketRequestType === "support") {
        this.retrieveTicketDetails(id);
      }
      this.setupAttachmentInterval(id);
    }
  }

  getDatacenters() {
    DataCenterApi.getAllDatacenters()
      .then((response) => {
        const validResponse = response.status === 200 && response.data;

        if (validResponse) {
          const datacenters = response.data?.datacenters;

          const startOfWeek = this.getStartOfWeek(datacenters);

          this.setState({ datacenters, startOfWeek });
        }
      })
      .catch(() => {});
  }

  checkModal = () => {
    const { setModalContent } = this.props;
    const { cancelRequested } = this.state;

    if (cancelRequested) {
      const headerText = "ARE you sure you want to cancel?";
      const button = (
        <BloxButton
          className="buttons41"
          id="confirm-cancel"
          text="YES"
          module="support"
          enabled={true}
          onClick={this.onCancelConfirm}
          cypressId="confirm-cancel"
        />
      );
      setModalContent(false, headerText, button);
    }
  };

  checkEventModal = () => {
    const { setModalContent } = this.props;
    const { cancelEventRequested } = this.state;

    if (cancelEventRequested) {
      const headerText = "ARE you sure you want to cancel?";
      const button = (
        <BloxButton
          className="buttons41"
          id="confirm-cancel-event"
          text="YES"
          module="support"
          enabled={true}
          onClick={this.cancelEvent}
          cypressId="confirm-cancel-event"
        />
      );
      setModalContent(false, headerText, button);
    }
  };

  updateEventRequest = () => {
    const {
      eventDetails,
      attendees,
      startdatetime,
      enddatetime,
      ticketDetails,
    } = this.state;
    const { setModalContent } = this.props;
    this.setState({ clicked: true });
    const startDate = new Date(startdatetime);
    const endDate = new Date(enddatetime);
    const params = {
      dataCenter: ticketDetails?.location,
      attendees,
      startDate: {
        year: startDate.getFullYear(),
        month: startDate.getMonth() + 1,
        day: startDate.getDate(),
        hour: this.formatHour(startDate.getHours()),
        minute: startDate.getMinutes(),
      },
      endDate: {
        year: endDate.getFullYear(),
        month: endDate.getMonth() + 1,
        day: endDate.getDate(),
        hour: this.formatHour(endDate.getHours()),
        minute: endDate.getMinutes(),
      },
      recurrence: null,
      reminder: null,
      eventDescription: "",
      eventSubject: "",
      id: eventDetails?.id,
    };

    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="billing"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    MicrosoftApi.updateEvent(params)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;

        if (validResponse) {
          this.toggleUpdateModal();
          this.getCalendarView();

          setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
        } else {
          setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
          this.setState({ clicked: false });
        }
      })
      .catch(() => {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
        this.setState({ clicked: false });
      });
  };
  refreshCalendarView = () => {
    this.setState({ events: null });
    this.getCalendarView();
  };
  getCalendarView() {
    const { selectedDay, datacenter } = this.state;
    const day = new Date(selectedDay);
    const params = {
      datacenter,
      startDate: {
        year: day.getFullYear(),
        month: day.getMonth() + 1,
        day: day.getDate(),
        hour: 9,
        minute: 0,
      },
      endDate: {
        year: day.getFullYear(),
        month: day.getMonth() + 1,
        day: day.getDate(),
        hour: 17,
        minute: 0,
      },
    };

    MicrosoftApi.getCalendarView(params)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;

        if (validResponse) {
          const formatedEvents = this.formatEvents(response.data?.events);
          this.setState({ events: formatedEvents, loading: false });
        } else {
        }
      })
      .catch(() => this.setState({ loading: false }));
  }

  updateTitle = (selected) => {
    this.setState({ title: selected });
  };

  formatEvents = (events) => {
    const formattedEvents = [];

    if (!events) {
      return [];
    }

    events.map((element, index) => {
      const startdatetime = new Date(element?.startDateTime?.dateTime);
      const enddatetime = new Date(element?.endDateTime?.dateTime);

      const start = new Date(
        startdatetime.getFullYear(),
        startdatetime.getMonth(),
        startdatetime.getDate(),
        startdatetime.getHours(),
        startdatetime.getMinutes()
      );
      const end = new Date(
        enddatetime.getFullYear(),
        enddatetime.getMonth(),
        enddatetime.getDate(),
        enddatetime.getHours(),
        enddatetime.getMinutes()
      );
      if (element?.status === "BUSY") {
        formattedEvents.push({
          id: index,
          title: "UNAVAILABLE",
          allDay: false,
          start,
          end,
        });
      }
    });
    return formattedEvents;
  };
  setNewStartDateTime = (value) => {
    this.setState(
      {
        startdatetime: value?.from,
        enddatetime: value?.to,
        selectedDay: value,
        events: null,
        showStart: false,
      },
      () => {
        this.getCalendarView();
      }
    );
  };
  setNewEndDateTime = (value) => {
    this.setState({ enddatetime: value });
  };
  resetSelectedDateTime = () => {
    this.setState({
      startdatetime: set(new Date(), { hours: 9, minutes: 0 }),
      enddatetime: set(new Date(), { hours: 10, minutes: 0 }),
    });
  };

  setNewStartTime = (newTime) => {
    const { startdatetime, duration } = this.state;
    const time = format(new Date(newTime), "hh:mm");

    const hours = time.getHours();
    const minutes = time.getMinutes();

    const value = set(new Date(startdatetime), { hours, minutes });
    const endValue = value.add(duration?.value, "m");

    this.setState({
      startdatetime: value,
      enddatetime: endValue,
      selectedDay: value,
    });
  };
  checkEventValid = (events, start, end) => {
    const overlaps = [];
    const endOfDay = set(start, { hours: 17 });
    events.map((event) => {
      if (
        isAfter(end, endOfDay) ||
        areIntervalsOverlapping(
          { start, end },
          { start: new Date(event?.start), end: new Date(event?.end) }
        )
      ) {
        overlaps.push(true);
      }
    });
    if (overlaps.length !== 0) {
      return false;
    } else {
      return true;
    }
  };

  formatHour = (hour) => {
    let newHour = hour;

    if (hour === "01" || hour === "02" || hour === "03" || hour === "04") {
      newHour = hour + 12;
    }
    return newHour;
  };

  onSelectedEndTime = (endTime) => {
    const { events } = this.state;

    if (events && events.length !== 0) {
      const currentSelected = events.filter(
        (event) => event.title === "selected"
      );
      const filteredEvents = events.filter(
        (event) => event.title !== "selected"
      );
      const valid = this.checkEventValid(
        events,
        currentSelected[0]?.start,
        endTime
      );
      if (currentSelected && valid) {
        this.setState({
          events: [
            ...filteredEvents,
            {
              start: currentSelected[0]?.start,
              end: endTime,
              title: "selected",
            },
          ],
          overlapping: false,
          startdatetime: currentSelected[0]?.start,
          enddatetime: endTime,
        });
      } else {
        this.setState({ overlapping: true });
      }
    }
  };

  getUserById = async (user_id) => {
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;

    try {
      const response = await this.userProfileApi.getUserById(user_id, id);
      if (response.status === 200 && !response.error) {
        return response;
      } else {
        return null;
      }
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  setNewEndTime = (newTime) => {
    const { enddatetime } = this.state;

    const time = format(new Date(newTime), "hh:mm");

    const hours = time.getHours();
    const minutes = time.getMinutes();

    const value = set(new Date(enddatetime), { hours, minutes });

    const end = new Date(
      value.getFullYear(),
      value.getMonth(),
      value.getDate(),
      hour,
      value.getMinutes()
    );

    this.onSelectedEndTime(end);

    this.setState({ enddatetime: value });
  };

  saveAttachments = (attachments, phase) => {
    const { newAttachments: existingAttachments } = this.state;
    if (phase !== "remove") {
      const filteredArray = [];
      attachments.forEach((attachment) => {
        if (
          existingAttachments.some(
            (existingAttachment) => existingAttachment.id === attachment.id
          )
        ) {
        } else {
          filteredArray.push(attachment);
        }
      });
      this.setState({
        newAttachments: existingAttachments.concat(filteredArray),
        attachmentModalOpen: false,
      });
    } else {
      this.setState({ newAttachments: attachments });
    }
  };

  toggleUpdateModal = () => {
    const { showUpdateModal } = this.state;
    this.setState({ showUpdateModal: !showUpdateModal });
  };

  getSize = (breakpoint) => {
    let size = "large";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };

  setStartTimeSelected = (start) => {
    this.setState({ startdatetime: start });
  };

  setEndTimeSelected = (end) => {
    this.setState({ enddatetime: end });
  };

  showStartDateTimeClock = () => {
    const { showStart } = this.state;
    this.setState({ showStart: !showStart });
  };

  setDuration = (duration, datetimeend) => {
    this.setState({ duration, datetimeend });
  };

  setAttendees = (attendees) => {
    this.setState({ attendees });
  };

  closeTour = (joyride) => {
    const { setHomeTour } = this.props;

    const action = joyride?.action;
    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action });
    }
  };

  render() {
    const {
      ticketDetails,
      showUpdateModal,
      attachmentModalOpen,
      error,
      eventDetails,
      startdatetime,
      enddatetime,
      duration,
      showStart,
      newAttachments,
      attachments,
      comments,
      comment,
      title,
      eventId,
    } = this.state;

    const {
      id,
      breakpoint,
      ticketType: ticketTypePermission,
      ticketRequestType,
      pages,
      runHomeTour,
      module,
      navigate,
      location,
    } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    const icon = getTicketTypeIcon(ticketDetails);

    const steps = [
      {
        title: "TicketDetail",
        content:
          "Let's take a look in the ticket detail. It is where you can add comments and view attachments on a ticket.",
        placement: "center",
        locale: { skip: "S-K-I-P" },
        target: ".header-section",
        module: "support",
      },
      {
        target: ".ticket-location-wrapper",
        content: "Here you will be able to see ticket details.",
        module: "support",
      },
      {
        target: ".ticket-details-wrapper",
        content:
          "Here you will find any description, attachments and event details linked to your ticket.",
        module: "support",
      },
      {
        target: ".ticket-comments-wrapper",
        content: "You can view and add ticket comments and attachments.",
        module: "support",
      },
      {
        target: ".header-section",
        content:
          "Finally in our support section, Let's check out our Ticket History.",
        module: "support",
        placement: "center",
        customNextButton: (
          <BloxButton
            className="buttons41"
            id="continue-tour"
            text="Continue"
            module="support"
            enabled={true}
            onClick={() =>
              navigate("/portal/support/ticket_history?tour=true", {
                state: { moduleOrder },
              })
            }
            cypressId="continue-tour"
          />
        ),
      },
    ];

    return (
      <BloxPage
        name="page ticket-detail-page"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`tourButton`} className="tourButton">
          {pages && (
            <Joyride
              steps={steps}
              continuous={true}
              tooltipComponent={JoyRideToolTip}
              run={runHomeTour}
              styles={{
                options: {
                  zIndex: 5000,
                },
              }}
              module={module}
              callback={this.closeTour}
              spotlightPadding={5}
              disableScrolling={true}
              disableBeacon={true}
              disableOverlayClose={true}
            />
          )}
        </div>
        <div key={`location`} className="location">
          <ComponentWrapper
            title={`${getTicketTitle(ticketDetails?.title)} - #${id}`}
            cypressId="ticket-location"
            titleClass="capitalize"
            hideBorder
          >
            {ticketDetails && (
              <TicketLocation
                icon={icon}
                onCancelRequest={this.onCancelRequest}
                ticketDetails={ticketDetails}
              />
            )}
            {error && <div className="body10">{error}</div>}
          </ComponentWrapper>
        </div>
        <div key={`details`} className="details">
          <ComponentWrapper title={title} titleClass="capitalize" hideBorder>
            {!error && (
              <TicketDetails
                ticketDetails={ticketDetails}
                ticketRequestType={ticketRequestType}
                updateTitle={this.updateTitle}
                attachments={attachments}
                ticketType={ticketTypePermission}
                getEventCardParams={this.getEventCardParams}
                eventId={eventId}
              />
            )}
          </ComponentWrapper>
        </div>
        <div key={`comments`} className="comments">
          <ComponentWrapper title="Communication" hideBorder>
            {!error && (
              <Comments
                ticketDetails={ticketDetails}
                breakpoint={breakpoint}
                attachFile={this.toggleAttachmentModal}
                newAttachments={newAttachments}
                onSubmit={this.onSubmit}
                description={comment}
                setDescription={this.setDescription}
                jiraComments={comments}
              />
            )}
            {attachmentModalOpen && (
              <Modal>
                <AttachmentModal
                  isOpen={attachmentModalOpen}
                  toggle={this.toggleAttachmentModal}
                  saveAttachments={this.saveAttachments}
                  //phase={phase}
                  breakpoint={breakpoint}
                  attachments={newAttachments}
                />
              </Modal>
            )}
            <PortraitModalComponent
              closeModal={this.toggleUpdateModal}
              show={showUpdateModal}
              header={
                <ModalHeader image={TopIcon} text={""} className="guest" />
              }
              title="UPDATE EVENT"
              subTitle={`EVENT DETAILS`}
              size={this.getSize(breakpoint)}
              breakpoint={breakpoint}
            >
              <CalendarModal
                location={ticketDetails?.location}
                eventDetails={eventDetails}
                type="update"
                refreshCalendarView={this.refreshCalendarView}
                setNewEndDateTime={this.setNewEndDateTime}
                setNewStartDateTime={this.setNewStartDateTime}
                resetSelectedDateTime={this.resetSelectedDateTime}
                setNewStartTime={this.setNewStartTime}
                setNewEndTime={this.setNewEndTime}
                setEvent={this.setEventDetails}
                startdatetime={startdatetime}
                enddatetime={enddatetime}
                duration={duration}
                setStartTimeSelected={this.setStartTimeSelected}
                setEndTimeSelected={this.setEndTimeSelected}
                setDuration={this.setDuration}
                setAttendees={this.setAttendees}
                showStartDateTimeClock={this.showStartDateTimeClock}
                showStart={showStart}
                breakpoint={breakpoint}
              />
              <ModalFooter
                cypressId="footer"
                id="footer"
                buttonText1="Update"
                buttonActive1={true}
                module="support"
                buttonFunction1={this.updateEventRequest}
                size={this.getSize(breakpoint)}
              />
            </PortraitModalComponent>
          </ComponentWrapper>
        </div>
      </BloxPage>
    );
  }
}

export default TicketHistoryDetail;
